<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M56 37.6V7.1a2 2 0 00-2-2H41a2 2 0 00-2 2v5a4 4 0 00-4 4 2 2 0 002 2h7a2 2 0 002-2 4 4 0 00-4-4v-4h11v29.5H7a2 2 0 00-2 2v.5a15 15 0 009.6 14l-3.1 3.1a1 1 0 000 1.41 1 1 0 001.41 0l3.86-3.85a15.59 15.59 0 003.23.34h24a15.59 15.59 0 003.23-.35l3.86 3.85a1 1 0 001.41 0 1 1 0 000-1.41l-3.1-3.1a15 15 0 009.6-14v-.5a2 2 0 00-2-2zM44 16.1h-7a2 2 0 012-2h3a2 2 0 012 2zm0 36H20a12 12 0 01-10.91-7h45.82a12 12 0 01-10.91 7zm11.61-9H8.39A12.07 12.07 0 018 40.6h48a12.07 12.07 0 01-.39 2.5z"/></svg>